import React, { useState, useEffect } from 'react'
import {
  Panel,
  Modal,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Button,
  Message,
  SelectPicker,
  ControlLabel,
} from 'rsuite'
import { isSupportFileByNameType, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import CustomIconMessageInfo from '../../widgets/CustomIconMessageInfo'
import TooltipButton from '../../components/buttons/TooltipButton'

export default function LawDocumentformForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onUpdate,
  onDelete,
  onPreview,
  onDownload,
  isChangSeqNo = true,
  onChangSeqNo = () => {},
  buttonText,
  schemafileCategory,
  schemaNote,
  ...props
}) {
  const { isEditErr, isUploadErr, isDeleteError, loading, disabledUpload, disabledEdit } = props
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [supportFileError, setSupportFileError] = useState(false)
  const [isOverSize, setIsOverSize] = useState(false)
  const [isNotSupportType, setIsNotSupportType] = useState(false)

  const defaultSupportType = '.jpg, .jpeg, .png, .pdf, .doc, .docx'

  useEffect(() => {
    setAttachFiles([...(schema.value || schema.values || [])])
    if (!isEditErr) {
      setEditName()
      setSelectEditeIndex(-1)
    }
  }, [schema])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])
  useEffect(() => {
    if (!isEditErr) {
      console.log('isEditErr', isEditErr)
    }
    setIsEditError(isEditErr)
  }, [isEditErr])
  useEffect(() => {
    setIsUploadError(isUploadErr)
    setIsAdd(isUploadErr)
  }, [isUploadErr])

  const onAdd = () => {
    setIsAdd(true)
    setSupportFileError(false)
    setFileList([])
  }

  const onAddFile = (file) => {
    setFileList(file)
    setValue(schema.name, file)
  }

  const handleDeleteFile = (index) => {
    setDeleteIndex(index)
    setIsdelete(true)
  }

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setSelectEditeIndex(index)
  }

  const onUploaderChange = (files) => {
    let file = files[files.length - 1]
    let isSupportSize = true
    let isSupportType = isSupportFileByNameType(
      file?.blobFile.name,
      schema.fileType || defaultSupportType
    )

    if (schema.fileSize && schema.fileSize > 0) {
      isSupportSize = file?.blobFile.size <= schema.fileSize * 1024 * 1024
      setIsOverSize(!isSupportSize)
    }

    setIsNotSupportType(!isSupportType)

    // console.log('isSupportType', isSupportType, 'isSupportSize', isSupportSize)

    if (!file || (isSupportType && isSupportSize)) {
      onAddFile(files)
      setSupportFileError(false)
    } else {
      files.splice(files.length - 1, 1)
      onAddFile(fileList)
      setSupportFileError(true)
    }
  }

  const validateEditFileName = (rowData, index) => {
    if (selectEditeIndex == index) {
      return (
        <>
          <Row>
            {isEditError && (
              <Col style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`แก้ไขไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                />
              </Col>
            )}
            <Col xs={19} sm={19} md={19} lg={19}>
              <Input value={editName} onChange={(value) => setEditName(value)} />
            </Col>
            <Col xs={5} sm={5} md={5} lg={5}>
              <ButtonGroup>
                <IconButton
                  appearance="ghost"
                  icon={<Icon icon="check" className="bt-gost-icon-radius" />}
                  onClick={(e) => {
                    onUpdate(rowData, editName)
                  }}
                />
                <IconButton
                  appearance="ghost"
                  className="rs-btn-ghost-cancel"
                  icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                  onClick={(e) => {
                    setEditName('')
                    setIsEditError(false)
                    setSelectEditeIndex(-1)
                  }}
                />
              </ButtonGroup>
            </Col>
          </Row>
        </>
      )
    } else {
      return rowData.label
    }
  }

  // console.log('999990090909 ', schema)

  return (
    <>
      {/* <Panel header={schema.buttonText} eventKey={2} shaded style={{ marginBottom: '2em' }}> */}
      {schema.description && (
        <Row style={{ marginTop: 10 }}>
          <CustomIconMessageInfo contents={schema.description} />
        </Row>
      )}

      {!isAdd && (
        <Row style={{ marginTop: 10 }}>
          <div>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="plus" />}
              onClick={onAdd}
              style={{ marginRight: 5 }}
              disabled={disabledUpload}
            >
              {`เพิ่ม${schema.buttonText || buttonText || ''}`}
            </IconButton>
          </div>
        </Row>
      )}
      {isAdd && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              {requiredFiled(schemafileCategory.validators, schemafileCategory.label)}
              <ErrorMessage error={errors[schemafileCategory.name]} style={{ marginBottom: 10 }} />
              <Controller
                name={schemafileCategory.name}
                control={control}
                defaultValue={schemafileCategory.value}
                rules={isValidators(schemafileCategory.validators)}
                render={(props) => {
                  return (
                    <SelectPicker
                      data={schemafileCategory.options}
                      searchable={false}
                      disabled={schemafileCategory.disabled}
                      value={props.value}
                      block
                      placeholder={schemafileCategory.hint || `เลือก${schemafileCategory.label}`}
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />
                  )
                }}
              />
            </Col>
            <Col lg={16} md={16} sm={24} xs={24}>
              <ErrorMessage error={errors[schemaNote.name]} style={{ marginBottom: 10 }} />
              <ControlLabel>{requiredFiled(schemaNote.validators, schemaNote.label)}</ControlLabel>
              <Input
                placeholder={schemaNote.hint}
                defaultValue={schemaNote.value}
                name={schemaNote.name}
                inputRef={register(isValidators(schemaNote.validators))}
              />
            </Col>
          </Row>
          <Row>
            <ErrorMessage error={errors[schema.name]} />
          </Row>

          <Controller
            key={schema.name}
            name={schema.name}
            control={control}
            rules={isValidators(schema.validators)}
            defaultValue={fileList}
          />
          <Row style={{ marginTop: 10 }}>
            <p>{`แนบไฟล์${schema.buttonText || ''}`}</p>
            <Message
              showIcon
              type="info"
              description={`ชนิดที่รองรับ : ${schema.fileType || defaultSupportType} ${
                schema.fileSize && schema.fileSize > 0
                  ? `, ขนาดไฟล์ไม่เกิน ${schema.fileSize} MB`
                  : ''
              }`}
            />
          </Row>
          <Row style={{ marginTop: 10 }}>
            {supportFileError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setSupportFileError(false)
                }}
                showIcon
                type="error"
                description={`${
                  isNotSupportType
                    ? `อัพโหลดไฟล์ได้เฉพาะที่รองรับเท่านั้น *** ชนิดที่รองรับ ${
                        schema.fileType || defaultSupportType
                      } ***`
                    : ''
                }  ${isOverSize ? ` ขนาดไฟล์เกิน ${schema.fileSize} MB ` : ''}`}
              />
            )}
            <Uploader
              accept={schema.fileType || defaultSupportType}
              autoUpload={false}
              fileList={props.value}
              listType="picture-text"
              onChange={(files) => {
                onUploaderChange(files)
              }}
              draggable
              // multiple={false}
            >
              <div style={{ lineHeight: '100px' }}>
                <Icon size="4x" icon="upload2" />
                <small
                  style={{
                    marginTop: '-70px',
                    display: 'block',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                >
                  คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่อใช้อัปโหลด
                </small>
              </div>
            </Uploader>
          </Row>
          {isUploadError && (
            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="error"
                description={`อัพโหลด${
                  schema.buttonText || ''
                }ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
              />
            </Row>
          )}
          <Row style={{ marginTop: 10 }}>
            <IconButton
              appearance="ghost"
              icon={<Icon className="bt-gost-icon-radius" icon="upload2" />}
              onClick={(e) => onSubmit()}
              style={{ marginRight: 5 }}
              disabled={loading || fileList?.length < 1}
            >
              {`บันทึก${schema.buttonText || ''}`}
            </IconButton>
            <IconButton
              appearance="ghost"
              className="rs-btn-ghost-cancel"
              icon={<Icon className="bt-gost-icon-radius-cancel" icon={'close'} />}
              onClick={(e) => {
                setIsAdd(false)
                setIsDeleteFail(false)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ยกเลิก${schema.buttonText || ''}`}
            </IconButton>
          </Row>
        </>
      )}
      <Row style={{ marginTop: 10 }}>
        {isDeleteFail && (
          <Row style={{ marginTop: 10 }}>
            <Message
              showIcon
              type="error"
              description={`ลบไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
            />
          </Row>
        )}
        <Table height={500} wordWrap bordered data={attachFiles}>
          <Column width={90} align="center" fixed>
            <HeaderCell>ไฟล์ที่</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={190}>
            <HeaderCell>หมวดหมู่ไฟล์</HeaderCell>
            <Cell dataKey="fileCategory" />
          </Column>

          <Column width={300}>
            <HeaderCell>ชื่อไฟล์</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return validateEditFileName(rowData, index)
              }}
            </Cell>
          </Column>

          <Column width={330} minWidth={330} flexGrow={1}>
            <HeaderCell>หมายเหตุ</HeaderCell>
            <Cell dataKey="note" />
          </Column>

          <Column width={200} align="center" fixed="right">
            <HeaderCell></HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <TooltipButton
                      isStart={true}
                      icon="eye"
                      tooltip={`แสดง`}
                      disabled={loading}
                      onClick={(e) => onPreview(rowData)}
                    ></TooltipButton>
                    <TooltipButton
                      isStart={false}
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      disabled={loading}
                      onClick={(e) => onDownload(rowData)}
                    ></TooltipButton>
                    {/* {!disabledEdit && (
                      <TooltipButton
                        isStart={false}
                        icon="pencil"
                        tooltip={`แก้ไข`}
                        disabled={loading || selectEditeIndex == index}
                        onClick={(e) => handleEditFile(rowData, index)}
                      ></TooltipButton>
                    )} */}
                    <TooltipButton
                      isStart={false}
                      icon="trash-o"
                      tooltip={`ลบ`}
                      disabled={loading}
                      onClick={(e) => handleDeleteFile(index)}
                    ></TooltipButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </Row>
      {/* </Panel> */}

      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
